module.exports = __webpack_public_path__ + "img/white_medical.c5b5b7d5.svg";